// For U.K. only
export const validatePostcode = postcode => fetch(`https://api.postcodes.io/postcodes/${postcode}/validate`)
  .then(response => response.json())
  .catch(error => ({ error }));
